<template>
    <v-app class="full-screen ma-0 pa-0" color="white">
        <v-container class="true-center bgzz"fluid >
            <v-row  justify="center">
                <v-col cols="12" sm="12" md="12" class="text-center">
                    <v-card style="" class="text-center max-300" elevation=24 >
                        <v-row>
                            <v-col cols="12" md="12" class="text-center mt-10">
                                <v-icon x-large class="icon-col">mdi-email-check-outline</v-icon>
                            </v-col>
                        </v-row>
                        <v-span class="">
                            <v-span class="txt1 text-center px-3" v-html="$t('zz_email_confirmation_text1')"></v-span>
                        </v-span>
                        <v-card-text class="justify-end">
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <div class="txt2 px-4" v-html="$t('zz_email_confirmation_text2')"></div>
                                    <!-- <div class="txtsub px-3" v-html="$t('zz_email_confirmation_text-subject')"></div> -->
                                    <div class="txt3 px-4 pt-5" v-html="$t('zz_email_confirmation_text3')"></div>
                                </v-col>
                            </v-row> 
                                       
                        </v-card-text>
                        <div class=" text-center pb-3 pt-5 col-12">
                            <img :src="juzzapLogo" height="25px"/>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
        
    
</template>
<script>

import Vue from 'vue'
import VeeValidate from "vee-validate";

import {TheMask} from 'vue-the-mask'

Vue.use(VeeValidate);
export default {
    props: {
    source: String
  },
  data: vm => ({
      
      overlaylogin:false,
      passwordreset:false,
      forgettype:false,
      forgetemail:'',
      codeError:false,
      valid: true,
      thumb:require('@/assets/Glovethumb.svg'),
      juzzapLogo:require('@/assets/juzzap-logo.svg'),
      emailanimation:require('@/assets/onboarding/emailed.gif'),
      juzzapLogoNew:require('@/assets/confirm-logo.svg'),
      logo:require('@/assets/logo.png'),
      emailsent:require('@/assets/onboarding/email-sent-confirmation.gif'),
      


    //   bannerImg:require('@/assets/restaurant.png'),
      bannerImg:require('@/assets/restaurant.svg'),

      

      
  }),
  mounted() {
    //this.$validator.localize("en", this.dictionary);
  },
  components: {TheMask},
  
}
</script>
<style scoped>

.true-center{
  display: grid;
  place-items: center;
  height: 100vh;
}
.full-screen{
    height:100vh;
    width:100vw;
}
.icon-col{
    color: #fe5800 !important;
    height: 25px;
}

.txt1{
    font-size: 20px;
    font-weight: 800;
    line-height: .9;
    color: rgb(69, 69, 69);
    text-align: center;
}
.txt2{
    font-size: 12px;
    text-align: center;
    line-height: 1.2;
}
.txt3{
    font-size: 10px;
    font-weight: 500;
    color: #fe5800;
    line-height: 1;
    text-transform: uppercase;
}
.txtsub{
    font-size: 14px;
    font-weight: 400;
    color: #000000;
}
</style>